import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../common/tab/tabActions';
import configLocal from '../configuracao/configLocal';

// inicia com valor para o <select> não ficarem vazio quando salvar sem alterar o <select> no insert
const INITIAL_VALUES = {
  dia: '',
  mes: '',
};

function decodeAnelFromPlanoId(dataEspecial) {
  const formData = { ...dataEspecial };
  const planoId = parseInt(formData.plano_id, 10);

  formData.anel1 = 0;
  formData.anel2 = 0;
  formData.anel3 = 0;
  formData.anel4 = 0;

  if (planoId >= 49 && planoId <= 62) {
    const bitmap = planoId - 48;
    formData.plano_id = 63;
    formData.anel1 = bitmap & 1 ? 1 : 0;
    formData.anel2 = bitmap & 2 ? 1 : 0;
    formData.anel3 = bitmap & 4 ? 1 : 0;
    formData.anel4 = bitmap & 8 ? 1 : 0;
  } else if (planoId === 63 || planoId === 32) {
    formData.anel1 = 1;
    formData.anel2 = 1;
    formData.anel3 = 1;
    formData.anel4 = 1;
  }

  return formData;
}

function processarAnelPayload(values) {
  const planoId = parseInt(values.plano_id, 10);
  const isVirtual = planoId === 63 || planoId === 32;

  let anelBitmap = 0;
  for (let index = 1; index <= 4; index++) {
    if (values[`anel${index}`]) {
      anelBitmap += Math.pow(2, index - 1);
    }
  }

  if (isVirtual) {
    if (anelBitmap === 0) {
      return { error: 'Selecione ao menos um anel para plano intermitente ou apagado.' };
    }

    return { anel: anelBitmap };
  }

  return { anel: 0 };
}

function exibirErrosSubmit(error) {
  const errors = error && error.response && error.response.data && error.response.data.errors;

  if (Array.isArray(errors) && errors.length > 0) {
    errors.forEach(message => toastr.error('Erro', message));
    return;
  }

  const message =
    (error && error.response && error.response.data && error.response.data.message) ||
    (error && error.message) ||
    'Erro ao salvar data especial';
  toastr.error('Erro', message);
}

export function getList() {
  var contId = configLocal.getConfig('cont');
  const request = axiosInstance.get(`/datasespeciais/${contId}`);

  return {
    type: 'DATAESPECIAL_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'DATAESPECIAL_PAGE',
  payload: pagina,
});

export function getControladorList() {
  const contId = configLocal.getConfig('cont');
  const numCont = configLocal.getConfig('numCont');
  const request = axiosInstance.get(`/datasespeciaisremote/${contId}/${numCont}`);

  return {
    type: 'DATAESPECIAL_FETCHED',
    payload: request,
  };
}

export function updateDataEspecialControlador(values) {
  const contId = configLocal.getConfig('cont');
  const request = axiosInstance.put(`/datasespeciaisremote/${contId}`, values);

  return {
    type: '',
    payload: request,
  };
}

export function removeDataEspecialControlador() {
  var contId = configLocal.getConfig('cont');
  const request = axiosInstance.delete(`/datasespeciais/controlador/deleteall/${contId}`);

  return {
    type: '',
    payload: request,
  };
}

export function createUpdateDataEspecialControlador(values) {
  var contId = values.controlador_id;

  const request = axiosInstance
    .post(`/datasespeciais/controlador/${contId}`, values)
    .then(resp => {
      toastr.success('Sucesso', 'Operação Realizada com sucesso.');
      //dispatch(init())
    })
    .catch(e => {
      e.response.data.errors.forEach(error => toastr.error('Erro', error));
    });

  return {
    type: '',
    payload: request,
  };
}

export function copiarDatasEspeciaisControladores() {
  let contId = configLocal.getConfig('cont');

  const request = axiosInstance.get(`/controladores/copiardatasespeciais/${contId}`);

  return {
    type: '',
    payload: request,
  };
}

export function updateDataEspecialControladorGeral(values) {
  let contId = configLocal.getConfig('cont');
  let grupoId = configLocal.getConfig('grupo');

  const request = axiosInstance.put(`/datasespeciaisremote/grupo/${contId}/${grupoId}`, values);

  return {
    type: '',
    payload: request,
  };
}

export function create(values) {
  return submit(values, 'post');
}

export function update(values) {
  return submit(values, 'put');
}

export function remove(values) {
  return submit(values, 'delete');

  // if (confirm('Deseja realmente excluir?')) {
  //     return submit(values, 'delete');
  // } else {
  //     return init();
  // }
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const contId = values.controlador_id;
    const anelPayload = processarAnelPayload(values);

    if (anelPayload.error) {
      toastr.error('Anéis', anelPayload.error);
      return;
    }

    const valuesWithAnel = { ...values, anel: anelPayload.anel };
    const config = method === 'delete' ? { data: valuesWithAnel } : valuesWithAnel;
    const args =
      method === 'delete'
        ? [`/datasespeciais/${contId}/${id}`, config]
        : [`/datasespeciais/${contId}/${id}`, valuesWithAnel];

    axiosInstance[method](...args)
      .then(resp => {
        toastr.success('Sucesso', 'Operação Realizada com sucesso.');
        dispatch(init());
      })
      .catch(exibirErrosSubmit);
  };
}

export function showUpdate(dataEspecial) {
  return [showTabs('tabUpdate'), selectTab('tabUpdate'), initialize('dataEspecialForm', decodeAnelFromPlanoId(dataEspecial))];
}

export function showDelete(dataEspecial) {
  return [showTabs('tabDelete'), selectTab('tabDelete'), initialize('dataEspecialForm', dataEspecial)];
}

export function init() {
  INITIAL_VALUES.controlador_id = configLocal.getConfig('cont');

  return [
    showTabs('tabList', 'tabCreate'),
    selectTab('tabList'),
    getList(),
    initialize('dataEspecialForm', INITIAL_VALUES),
  ];
}
